import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Random24dxadk52mliy as Random,
  takeUpperBits23varjnd7v1uz as takeUpperBits,
} from './Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkInvariants($this) {
  // Inline function 'kotlin.require' call
  if (!!(($this.lo_1 | $this.mo_1 | $this.no_1 | $this.oo_1 | $this.po_1) === 0)) {
    var message = 'Initial state must have at least one non-zero element.';
    throw IllegalArgumentException().s2(toString(message));
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.so_1 = 0n;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var XorWowRandomClass;
function XorWowRandom() {
  if (XorWowRandomClass === VOID) {
    class $ extends Random() {
      static to(x, y, z, w, v, addend) {
        var $this = this.bo();
        $this.lo_1 = x;
        $this.mo_1 = y;
        $this.no_1 = z;
        $this.oo_1 = w;
        $this.po_1 = v;
        $this.qo_1 = addend;
        checkInvariants($this);
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < 64)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            $this.sk();
          }
           while (inductionVariable < 64);
        return $this;
      }
      static ro(seed1, seed2) {
        return this.to(seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ (seed2 >>> 4 | 0));
      }
      sk() {
        var t = this.lo_1;
        t = t ^ (t >>> 2 | 0);
        this.lo_1 = this.mo_1;
        this.mo_1 = this.no_1;
        this.no_1 = this.oo_1;
        var v0 = this.po_1;
        this.oo_1 = v0;
        t = t ^ t << 1 ^ v0 ^ v0 << 4;
        this.po_1 = t;
        this.qo_1 = this.qo_1 + 362437 | 0;
        return t + this.qo_1 | 0;
      }
      co(bitCount) {
        return takeUpperBits(this.sk(), bitCount);
      }
    }
    initMetadataForClass($, 'XorWowRandom');
    XorWowRandomClass = $;
  }
  return XorWowRandomClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  XorWowRandom as XorWowRandom4dcuf9lla8j1,
};
//endregion

//# sourceMappingURL=XorWowRandom.mjs.map
